window.$$ = function (selector, parent) {
    return (parent || document).querySelector(selector);
};
window.$$$ = function (selector, parent) {
    return Array.prototype.slice.call((parent || document).querySelectorAll(selector));
};
